/**
 * prdリリースする際のNewIconのお知らせ表示期間(週単位)を設定する
 */
export const displayWeeksForNewIcon = 4;

/**
 * prdリリースする際のUpdateIconのお知らせ表示期間(週単位)を設定する
 */
export const displayWeeksForUpdateIcon = 1;
